import React from 'react'
import PropTypes from 'prop-types'

function Input({
  type,
  name,
  id,
  value,
  label,
  errorMessage,
  isRequired,
  onChange,
  ...otherProps
}) {
  return (
    <div className={`mz-form-item mz-form-item--${type}`}>
      <input
        type={type}
        name={name}
        className='mz-form-item__textfield'
        id={id}
        value={value}
        required={isRequired}
        onChange={onChange}
        {...otherProps}
      />
      {
        label && (
          <label
            className={`mz-form-item__label ${value.length ? 'shrink' : ''}`}
            htmlFor={id}
          >
            {label}{(isRequired && label) && (<span className="mz-form-item__required-star">*</span>)}
          </label>
        )
      }
      {errorMessage && (
        <div className="mz-form-item__error-message">{errorMessage}</div>
      )}
    </div>
  )
}

Input.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  otherProps: PropTypes.object,
}

export default Input